import { render, staticRenderFns } from "./DsResult.vue?vue&type=template&id=0937dcc8&scoped=true&"
import script from "./DsResult.vue?vue&type=script&lang=js&"
export * from "./DsResult.vue?vue&type=script&lang=js&"
import style0 from "./DsResult.vue?vue&type=style&index=0&id=0937dcc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937dcc8",
  null
  
)

export default component.exports